import styles from "./tooltips.module.css"
import React, {useState, useRef, useEffect} from "react"
import PropTypes from "prop-types"
import * as fonts from "shared/fonts"
import cx from "classnames"

const QuestionMark = ({fill = "1D1726"}) => (
  <svg x="0px" y="0px" viewBox="0 0 16 16" style={{enableBackground: "new 0 0 16 16"}} fill={`#${fill}`}>
    <path
      d="M8,0C3.5888672,0,0,3.5885417,0,8s3.5888672,8,8,8s8-3.588542,8-8S12.4111328,0,8,0z M8,12.8336592
      c-0.5522461,0-1-0.447917-1-1c0-0.5524092,0.4477539-1,1-1c0.5523272,0,1,0.4475908,1,1
      C9,12.3857422,8.5523272,12.8336592,8,12.8336592z M8,9.8336592c-0.5524087,0-1-0.447917-1-1
      c0-0.552084,0.4475913-1.0000005,1-1.0000005c0.7353516,0,1.333333-0.5983071,1.333333-1.333333S8.7353516,5.1669922,8,5.1669922
      S6.6666665,5.7652993,6.6666665,6.5003257c0,0.552083-0.4475908,1-1,1s-1-0.447917-1-1
      c0-1.8378906,1.4954429-3.3333335,3.3333335-3.3333335s3.333333,1.4954429,3.333333,3.3333335S9.8378906,9.8336592,8,9.8336592z"
    />
  </svg>
)

const moods = {
  intense: "1D1726",
  subtle: "5c5761"
}

const Tooltip_ = ({flip, children}) =>
  flip ? (
    <span>
      <div className={styles["flipped-text"]}>{children}</div>
      <span className={cx(styles["disclaimer-tooltip"], styles["flipped"], fonts.getFontClass())}>
        <div className={styles["hidden"]}>{children}</div>
      </span>
    </span>
  ) : (
    <span className={cx(styles["disclaimer-tooltip"], fonts.getFontClass())}>{children}</span>
  )

export const Tooltip = ({children, mood = "intense", isFirst, className, align, showIcon = true}) => {
  const [show, setShow] = useState(false)

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setShow(false)
    }
  }

  useEffect(() => {
    if (show) {
      document.addEventListener("keydown", handleKeyDown)
    } else {
      document.removeEventListener("keydown", handleKeyDown)
    }
    return () => document.removeEventListener("keydown", handleKeyDown)
  }, [show])

  return (
    <button
      onClick={() => {
        setShow(!show)
      }}
      onBlur={() => setShow(false)}
      style={{border: "none", background: "none", padding: "0", margin: "0"}}
    >
      <span
        style={{verticalAlign: align}}
        className={cx(className, styles["disclaimer"], fonts.getFontClass())}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        aria-label={children}
        role="tooltip"
      >
        {showIcon && <QuestionMark fill={moods[mood]} />}
        {show && <Tooltip_ flip={isFirst}>{children}</Tooltip_>}
      </span>
    </button>
  )
}

Tooltip.propTypes = {
  mood: PropTypes.oneOf(["intense", "subtle"])
}

/**
 *
 * @param {Object} param0 - Takes an object that has the tooltip content as well as the boundingrect of the hovered item
 */

export const HoverTooltip = ({tooltipContent, hoverArea}) => {
  const toolTipRef = useRef(null)
  useEffect(() => {
    if (hoverArea) {
      toolTipRef.current.style.top = hoverArea.y + window.scrollY - 8 + "px"
      toolTipRef.current.style.left = hoverArea.x + hoverArea.width / 2 + "px"
    } else {
      toolTipRef.current.style.left = "-1000px"
      toolTipRef.current.style.top = "-1000px"
    }
  }, [hoverArea])

  return (
    <div ref={toolTipRef} className={cx(styles["hover--tooltip"])}>
      <div className={cx(styles["hover--container"])}>
        <div>{tooltipContent}</div>
      </div>
    </div>
  )
}
